// ** MUI Imports
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

// ** Custom Components Imports

import PageHeader from '../../@core/components/page-header'
import CardStatsHorizontalWithDetails from '../../@core/components/card/card-stats-horizontal-with-details';
import { useEffect, useState } from 'react';
import { DashboardData } from "../../hooks/dashboard";
import { useSmartClaim } from '../../hooks/smartClaim';
import { useTrueClaim } from '../../hooks/trueClaim';
import { userData } from '../../hooks/userData';

const Dashboard = () => {
  const dashboard = DashboardData()
  const sc_claim = useSmartClaim();
  const tc_claim = useTrueClaim()
  const gst_claim = userData()

  const [smartClaim, setSmartClaim] = useState([
    { icon: "tabler:user", stats: 0, title: "Customer Return", id: "customer_return", href: '/customer-return' },
    { icon: "tabler:user-plus", stats: 0, title: "Wrong Rto", avatarColor: "error", id: "wrong_rto", href: '/wrong-rto' },
    { icon: "tabler:user-check", stats: 0, trend: "negative", title: "Non Barcode Rto", avatarColor: "success", id: "non_barcode_rto", href: '/non-barcode-rto' },
    { icon: "tabler:user-exclamation", stats: 0, title: "Damage", avatarColor: "warning", id: "damage", href: '/damage' },
    { icon: "tabler:user-exclamation", stats: 0, title: "Missing Qty", avatarColor: "warning", id: "missing_qty", href: '/missing-qty' }
  ]);

  const [trueClaim, setTrueClaim] = useState([
    {
      icon: "tabler:user",
      stats: 0,
      title: "Payment Not Receive",
      subject: "paymentNotReceived",
      id: "payment",
      href: '/payment'
    },
    {
      icon: "tabler:user-plus",
      stats: 0,
      title: "Return Not Receive",
      subject: "returnNotReceived",
      avatarColor: "error", id: "return", href: '/return'
    },
    {
      icon: "tabler:user-check",
      stats: 0,
      trend: "negative",
      title: "Lost",
      subject: "lost",
      avatarColor: "success", id: "lost", href: '/lost'
    },
    {
      icon: "tabler:user-exclamation",
      stats: 0,
      title: "Otp Less",
      subject: "otpLessDelivered",
      avatarColor: "warning", id: "otp_less", href: '/otp-less'
    },
  ])

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        tc_claim.setTotalCounts()
        // await Promise.all([
        await tc_claim.trueClaim({ returnNotReceived: true, isCompleted: false });
        await tc_claim.trueClaim({ intransit: true, isCompleted: false });
        await tc_claim.trueClaim({ paymentNotReceived: true, isCompleted: false });
        await tc_claim.trueClaim({ orderType: "LOST", isCompleted: false });
        // ]);
        // tc_claim.setTotalCounts();  // Call only once after all requests
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    };

    if (gst_claim.user) {
      // fetchCounts();
    }
  }, [gst_claim.user])

  useEffect(() => {
    if (!sc_claim.totalCounts) return;  // Ensure totalCounts exists before updating

    setSmartClaim(prevSmartClaim =>
      prevSmartClaim.map(item => ({
        ...item,
        stats: sc_claim.totalCounts[item.id] ?? 0  // Update existing array directly
      }))
    );
    if (tc_claim.totalCounts) {
      setTrueClaim(prevSmartClaim =>
        prevSmartClaim.map(item => ({
          ...item,
          stats: tc_claim.totalCounts[item.id] ?? 0  // Update existing array directly
        }))
      );
    }
  }, [sc_claim.totalCounts, tc_claim.totalCounts]);

  return (
    <Grid container spacing={6}>
      <PageHeader
        title={
          <Typography variant='h3'>
            Welcome to Claim Panel
          </Typography>
        }
      />

      <Grid item xs={12}>
        <Typography variant='h4'>
          True Claim
        </Typography>
        <Grid container spacing={6}>
          {trueClaim.map((item, index) => {
            return (
              <Grid item xs={12} md={3} sm={6} key={index}>
                <CardStatsHorizontalWithDetails {...item} />
              </Grid>
            )
          })}
        </Grid>

      </Grid>

      <Grid item xs={12}>

        <Typography variant='h4'>
          Smart Claim
        </Typography>
        <Grid container spacing={6}>
          {smartClaim.map((item, index) => {
            return (
              <Grid item xs={12} md={3} sm={6} lg={2} key={index}>
                <CardStatsHorizontalWithDetails {...item} />
              </Grid>
            )
          })}
        </Grid>

      </Grid>
    </Grid>
  )
}

export default Dashboard
